import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import globalStyles from "../../../../../assets/styles/global.module.scss";
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from "../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import workflowStyles from "../../../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss";
import RetrieveContactPopup from './retrieveContact/retrieveContactPopup';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { retrieveContactActionListData } from '../../../../../models/flowBuilderTypes';
import { getRetrieveContactValueText } from '../../flowBuilderConstants';

const RetrieveContactComponent = (props: any) => {
    
    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');

    const [flagRetrieveContactPopup, setFlagRetrieveContactPopup] = useState<boolean>(false);

    const { onChangeCurrentActiveNodeConfig, nodes, setNodes, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const storeBackupValue = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "store_backup_value" },
            {
                updateType: "editExistingStepAction"
            }
        )
    } 

    const handleCancelClick = () => {
        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id,
            { type: "cancel_changes" },
            {
                updateType: "editExistingStepAction"
            }
        ); 
        setFlagRetrieveContactPopup(false);
    } 
    
    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                Retrieve Contact
                            </Grid>
                            <Grid item className={`${styles.contentBlockSubHeadingStyle} ${workflowStyles.resetVariableText}`}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item className={globalStyles.wordBreakBreakWord}>
                                        {getRetrieveContactValueText(actionData)}
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon className={styles.editActionIcon} onClick={() => { setFlagRetrieveContactPopup(true); storeBackupValue(); }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {flagRetrieveContactPopup &&
                    <GlobalPopUp
                        open={flagRetrieveContactPopup}
                        onClose={() =>  { handleCancelClick() }}
                        paperMinWidth={flagSmallScreen ? "280px" : "850px"}
                        paperMaxwidth={flagSmallScreen ? "580px" : "850px"}
                        flagShowCloseIcon={true}
                        titlePadding='0'
                        handleClose={() => { handleCancelClick() }}
                    >
                        <RetrieveContactPopup actionData={actionData} stepAction={stepAction} setFlagRetrieveContactPopup={setFlagRetrieveContactPopup} handleCancelClick={handleCancelClick} />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default RetrieveContactComponent
